import React from 'react';
import { partners } from '../mock';

const Partners = () => {
  return (
    <section className="py-14 bg-white border-y border-[color:var(--brand-50)]">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <h3 className="text-center font-display text-2xl md:text-3xl font-bold text-[color:var(--ink)] reveal">Partner Kami</h3>

        <div className="mt-10 flex flex-wrap items-center justify-center gap-6 reveal">
          {partners.map((p) => (
            <a
              key={p.name}
              href="https://share.google/Siz5lJEG4uCWuGrL9"
              target="_blank"
              rel="noreferrer"
              aria-label={`Buka ${p.name}`}
              className="group flex flex-col items-center gap-3 p-6 rounded-2xl bg-white border border-[color:var(--brand-50)] hover:border-[color:var(--brand)] hover:shadow-xl hover:-translate-y-1.5 transition-all duration-300 w-full max-w-xs cursor-pointer"
            >
              <div className="h-24 w-24 rounded-full bg-white flex items-center justify-center overflow-hidden border border-[color:var(--brand-50)] group-hover:border-[color:var(--brand)] transition-colors animate-float">
                <img
                  src={p.logo}
                  alt={p.name}
                  className="w-full h-full object-contain p-2 transition-transform duration-500 group-hover:scale-110 group-hover:rotate-6"
                  loading="lazy"
                />
              </div>
              <div className="text-center">
                <div className="font-display font-bold text-[color:var(--ink)] group-hover:text-[color:var(--brand)] transition-colors">{p.name}</div>
                <div className="text-xs text-[color:var(--muted)] mt-0.5 group-hover:text-[color:var(--brand)] transition-colors">Coffee Partner ↗</div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Partners;
